<template>
  <div class="modal-container" :class="{ visible: isVisible }">
    <div class="modal" :style="{ width }">
      <div class="modal-header">
        <div class="modal-title">{{ title }}</div><a role="button" class="close-button" @click="onCloseClicked">{{
          labels.close }}</a>
      </div>
      <div class="modal-body">
        <slot> </slot>
      </div>
    </div>
  </div>
</template>

<script>
import Labels from "../services/labels.js";

export default {
  name: "Modal",
  props: ["visible", "width", "title"],
  components: {

  },
  data() {
    return {
      labels: Labels,
      isVisible: this.visible || false,
    };
  },
  watch: {
    visible(val) {
      this.isVisible = val;
      const body = document.getElementsByTagName("BODY")[0];
      if (val) {
        body.classList.add("noscroll");
      } else {
        body.classList.remove("noscroll");
      }
    },
  },
  mounted() {
    if (this.visible) {
      const body = document.getElementsByTagName("BODY")[0];
      body.classList.add("noscroll");
    }
  },
  beforeDestroy() {
    if (this.visible) {
      const body = document.getElementsByTagName("BODY")[0];
      body.classList.remove("noscroll");
    }
  },
  methods: {
    onCloseClicked() {
      this.$emit("close");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-container.visible {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border: 1px solid #888;
  box-sizing: border-box;
  box-shadow: 5px 5px 15px -2px #000000;
  padding: 40px;
  max-width: 100%;
}

.modal .modal-header {
  display: flex;
}

.modal .modal-title {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  padding-bottom: 10px;
  flex-grow: 1;
  color: #323232;
}

.modal .modal-header .close-button {
  color: #323232;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  display: block;
  padding-right: 23px;
  background-image: url("data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6846 2.05694L13.2878 0.660156L7.7002 6.24775L2.1126 0.660156L0.71582 2.05694L6.30341 7.64453L0.71582 13.2321L2.1126 14.6289L7.7002 9.04131L13.2878 14.6289L14.6846 13.2321L9.09698 7.64453L14.6846 2.05694Z' fill='%23323232'/%3E%3C/svg%3E");
  background-position: 100% 0;
  background-repeat: no-repeat;
  background-size: 14px;
}

.modal .modal-body {
  padding: 10px 0;
  position: relative;
}

.modal .modal-footer {
  border-top: 1px solid #999;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.modal .modal-footer>.button {
  min-width: 80px;
}

@media all and (max-width: 780px) {
  .modal {
    padding: 20px;
    overflow-y: auto;
    max-height: 100vh;
  }

  .modal .clariant-map-container {
    max-width: 100vw;
    width: calc(100vw - 40px) !important;
  }

  .modal .modal-header {
    flex-direction: column-reverse;
  }

  .modal .modal-header .close-button {
    align-self: flex-end;
  }

  .modal .modal-title {
    margin-top: 20px;
    font-size: 18px;
    line-height: 22px;
  }
}
</style>
